/**
 * Created by Slava on 18.06.2024
 */

LoseWindow.prototype.setupChildren = cleverapps.extendFunc(LoseWindow.prototype.setupChildren, function () {
    this._super();

    this.buttons.setAlignment(cleverapps.styles.LoseWindow.button);
    this.windowTitle.setAlignment(cleverapps.styles.LoseWindow.title);
});
